export default "__VITE_ASSET__Ceb0xiRL__"